// extracted by mini-css-extract-plugin
export default {"chatTreeContainer":"ChatModal_chatTreeContainer__m7ozr","chatTree":"ChatModal_chatTree__3qisb","active":"ChatModal_active__lWEdI","chatTreeIcon":"ChatModal_chatTreeIcon__NFk1o"};